/**
 * @author HungNS
 */
import FactoryService from '@/services/FactoryService.js'
import * as TYPE from './type'
import IConstants from '@/common/constants/IConstants'
import ServiceUtils from '@/common/utils/ServiceUtils'
import i18n from '@/lang/i18n'
import Vue from 'vue'
import { isEmpty } from 'lodash'
const forceNewsService = FactoryService.getService('forceNews');

/* eslint-disable no-unused-vars */

const moduleNews = {
    namespaced: true,
    state: () => ({
        systemCache: null,
        customerInfoResponse: null,
        customerInfoView: null,
        formName: 'edit_individual',
        isCorporation: false,

        inputArr: [],

        hasAdditionEmail: false,
        enableGoogleAuthFlag: false,
        disableGoogleAuthFlag: false,
        showVerifyCode: false,

        SUPPORT_DOCUMENT_URL: '',
        SUPPORT_DOMINATOR_URL: '',
        SUPPORT_FORM_URL: '',
        NEW_UPLOAD_DOCUMENT_URL: '',

        remainForceNewsList:[]


    }),
    mutations: {
        [TYPE.SET_SYSTEM_CACHE](state, payload) {
            state.systemCache = {...payload};
        },

        [TYPE.SET_AMS_CUSTOMER_INFO](state, payload) {
            initInput(state, payload);
        },

        [TYPE.SET_REMAIN_FORCE_NEWS_LIST](state, payload){
            state.remainForceNewsList = payload
        }

    },
    actions: {
        async [TYPE.GET_SYSTEM_CACHE]({commit}) {
            const data = await forceNewsService.loadSystemCache();
            commit(TYPE.SET_SYSTEM_CACHE, data)
        },
        async [TYPE.GET_AMS_CUSTOMER_INFO]({commit, rootState}) {
            const data = await forceNewsService.getAmsCustomerInfo();
            commit(TYPE.SET_AMS_CUSTOMER_INFO, {data, rootState})
        },
        async [TYPE.INIT_FORCE_NEWS]({dispatch}) {
            await dispatch(TYPE.GET_SYSTEM_CACHE);
            await dispatch(TYPE.GET_AMS_CUSTOMER_INFO)
        },
        [TYPE.SET_REMAIN_FORCE_NEWS_LIST]({commit}, payload) {
            commit(TYPE.SET_REMAIN_FORCE_NEWS_LIST, payload);
        },
    },
    getters: {
        listPrefecture(state) {
            const {systemCache} = state;
            let result = [];
            let listPrefecture = [];
            if (systemCache) {
                for (const index in systemCache.mapPrefecture) {
                    listPrefecture.push({value: systemCache.mapPrefecture[index]});
                }
                if (listPrefecture.length > 0) {
                    for (const prefecture in listPrefecture) {
                        if (listPrefecture[prefecture].value == 'nts.prefecture.default') {
                            result.push({key: "", value: i18n.t(listPrefecture[prefecture].value)});
                        } else {
                            result.push({
                                key: ServiceUtils.convertHalfwidthToFullwidthReturn(i18n.t(listPrefecture[prefecture].value)),
                                value: i18n.t(listPrefecture[prefecture].value)
                            });
                        }
                    }
                }

            }
            return result;
        },
        amsWhitelabelConfigInfo(state) {
            if (state.systemCache) {
                return state.systemCache.amsWhitelabelConfigInfo
            }
            return [];
        },
        mapGroupFieldAmsCustomer(state){
            if (state.systemCache) {
                return state.systemCache.mapGroupFieldAmsCustomer
            }
            return null;
        },
        mapReportTemplateCache(state) {
            if (state.systemCache) {
                return state.systemCache.mapReportTemplateCache
            }
            return null;
        },
        getForceNewsCustomerInfoView(state){
            if (state.customerInfoView) {
                return state.customerInfoView;
            }
            return null;
        }
    }

};


const initInput = (state, payload) => {
    const {data, rootState} = payload;
    state.customerInfoResponse = data;
    state.SUPPORT_DOCUMENT_URL = data.supportDocumentUrl;
    state.SUPPORT_DOMINATOR_URL = data.supportDominatorUrl;
    state.SUPPORT_FORM_URL = data.supportFormUrl;
    state.NEW_UPLOAD_DOCUMENT_URL = data.newDocumentUploadUrl;
    state.customerInfoView = data.amsCustomerInfoView;
    if (state.customerInfoView.corporationType === IConstants.CUSTOMER_TYPE.INDIVIDUAL) {
        state.isCorporation = false;
        state.formName = "edit_individual";
    } else {
        state.isCorporation = true;
        state.formName = "edit_corporation";
    }

    const {customerInfoView} = state;
    let input = {};
    for (const fieldAmsCustomer in customerInfoView) {
        if (fieldAmsCustomer == "investmentView" || fieldAmsCustomer == "cryptInvestmentPurposeView") {
            input["amsCustomerDetail." + fieldAmsCustomer] = customerInfoView[fieldAmsCustomer];
        } else if (fieldAmsCustomer == "additionalEmail") {
            input["amsCustomerDetail." + fieldAmsCustomer] = customerInfoView[fieldAmsCustomer];
            if (customerInfoView[fieldAmsCustomer]) {
                state.hasAdditionEmail = true;
            }
        } else if (fieldAmsCustomer == "picPerfecture" || fieldAmsCustomer == "prefecture") {
            input["amsCustomerDetail." + fieldAmsCustomer] = ServiceUtils.convertHalfwidthToFullwidthReturn(customerInfoView[fieldAmsCustomer]);
        } else {
            input["amsCustomerDetail." + fieldAmsCustomer] = customerInfoView[fieldAmsCustomer];
        }
    }

    // 2Fa vue add
    input['amsCustomerDetail.verifyCode'] = "";

    //Update password add
    input['amsCustomerDetail.newPassword'] = "";
    input['amsCustomerDetail.currentPassword'] = "";
    input['amsCustomerDetail.reTypePassword'] = "";

    const listForceNewsInfo = JSON.parse(JSON.stringify(rootState)).news.listForceNewsInfo;
    if (!isEmpty(listForceNewsInfo)) {
        listForceNewsInfo.map((item, index) => {
            const newInput = {messageId: item.messageId, ...input};
            Vue.set(state.inputArr, index, newInput);
            state.remainForceNewsList.push(item.messageId);
        })
    }
};

export default moduleNews;
